export default __webpack_public_path__ + "static/sand-9a2cf9f160a8a28aaf0bae630a70e2ea.webp";